import React from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import './App.css';
import RegistrationPage from './pages/RegistrationPage';
import ComponentsPage from './pages/ComponentsPage';
import DefaultPage from './pages/DefaultPage';
import MemberDashboard from './pages/member/MemberDashboard';
import MemberSettings from './pages/member/MemberSettings';
import Header from './components/Header';
import Footer from './components/Footer';
import ErrorPage from './pages/ErrorPage';
import AdminPage from './pages/admin/AdminPage';
import AdminSettingsPage from './pages/admin/settings/AdminSettingsPage';
import AttendancePage from "./pages/AttendancePage";
import "./styles/custom.scss";
import { MemberLayout, MemberProvider } from './pages/member/MemberContext';
import { AdminLayout, AdminProvider } from './pages/admin/AdminContext';
import { AdminSettingsLayout } from './pages/admin/settings/AdminSettingsContext';
import { Toaster } from 'react-hot-toast';

// Add pages and their URLs here
const router = createBrowserRouter([
    { path: '/', element: <DefaultPage /> },
    { path: '/register', element: <RegistrationPage /> },
    { 
        path: '/member', 
        element: <MemberLayout />, // Wraps both routes inside MemberProvider
        errorElement: <ErrorPage />,
        children: [
            { index: true, element: <Navigate to="dashboard" replace /> },
            { path: 'dashboard', element: <MemberDashboard /> },
            { path: 'settings', element: <MemberSettings /> },
        ]
    },
    { path: '/register', element: <RegistrationPage />, errorElement: <ErrorPage /> },
    { path: '/admin', 
        element: <AdminLayout />, 
        children: [
            { index: true, element: <Navigate to="/admin/members" replace /> }, // Default to members tab
            { path: ':tab', element: <AdminPage /> }, // Loads different tabs dynamically
        ],

    },
    // { path: '/admin/:tab', element: <AdminPage />, errorElement: <ErrorPage /> },
    // { path: '/admin/settings/:tab', element: <Navigate to="/admin/settings/members" replace /> }, // Reroute /admin/settings to /admin/settings/members
    { path: '/admin/settings', 
        element: <AdminSettingsLayout />, 
        children: [
            { index: true, element: <Navigate to="/admin/settings/semesters" replace /> }, // Default to semesters tab
            { path: ':tab', element: <AdminSettingsPage /> }, // Loads different tabs dynamically
        ],

    },
    { path: '/admin/settings/:tab', element: <AdminSettingsPage />, errorElement: <ErrorPage />},
    { path: '/components', element: <ComponentsPage /> },
    { path: '/attendance', element: <AttendancePage />, errorElement: <ErrorPage/>},
    { path: '*', element: <ErrorPage /> }, // Catch-all route
]);


const App = () => {
    console.log("Current API URL: ", process.env.REACT_APP_API_URL);
    return (
        <>
            <Header />
            <Toaster />
            <RouterProvider router={router} />
            <Footer />
        </>
    );
};

export default App;